import { render, staticRenderFns } from "./TaskToDoList.vue?vue&type=template&id=77ad1db6&scoped=true"
import script from "./TaskToDoList.vue?vue&type=script&lang=js"
export * from "./TaskToDoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ad1db6",
  null
  
)

export default component.exports